export default "__VITE_ASSET__nuI0FHru__"